import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
//------------------------------------------------------------
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import cognito_ja from './cognito-ja';

/*開発者側なので一旦無視 */
Amplify.configure({
  aws_cognito_region: "ap-northeast-1",
  aws_user_pools_id:  "ap-northeast-1_IP7zjlVaV",
  aws_user_pools_web_client_id: "7fl4cvjj82botbl79i6qho3njp",
  aws_mandatory_sign_in: "enable"
});
//a
let languageDict = cognito_ja

AmplifyModules.I18n.putVocabularies(languageDict)
Vue.use(AmplifyPlugin, AmplifyModules);
//-------------------------------------------------------
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
//Vue.component('loading', Loading);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
